import { ImageLoaderProps } from 'next/image'

/**
 * Custom Image Loader cho Next.js để điều hướng qua /_next/image/ (có gạch chéo cuối)
 * Tránh lỗi Redirect 308 khi trailingSlash = true trong next.config.ts
 */
export const customImageLoader = ({ src, width, quality }: ImageLoaderProps): string => {
  // Với các ảnh SVG, base64 hoặc các đường dẫn đặc biệt không cần qua optimizer, trả về gốc
  if (src.endsWith('.svg') || src.startsWith('data:')) {
    return src
  }
  
  const params = new URLSearchParams()
  params.set('url', src)
  params.set('w', width.toString())
  params.set('q', (quality || 75).toString())

  return `/_next/image/?${params.toString()}`
}
